import React, { Component } from 'react';
import Formulario from './InformesForm';

class Informes extends Component{
    componentDidMount = () => {
        const { getModulo } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
    }
    render(){
        const { loader, modulo, reporteDetalleGastosProyecto, listarProyectos} = this.props;
        return(
            <div>
                <Formulario
                    loader = {loader}
                    modulo = {modulo}
                    listarProyectos = {listarProyectos}
                    reporteDetalleGastosProyecto = {reporteDetalleGastosProyecto}
                />
            </div>
        );
    }
}

export default Informes;
